import { handleModalKeydown } from "../utils";
export default class SlpRefinement {
    constructor(filter, initData) {
        this._offerFilter = null;
        this._appliedTypeFilters = [];
        this._appliedTagFilters = [];
        this._appliedTagFiltersByKind = {};
        this._selectedTypeFilters = [];
        this._selectedTagFiltersByKind = {};
        this.setUpFilterAndState = () => {
            this.setFiltersFromUrl();
            this._filter(this._offerFilter, this._appliedTypeFilters, this._appliedTagFilters);
            this.setOfferFilterStyle();
        };
        this.setOfferFilterStyle = () => {
            const currentSelection = this._offerFilterContainer?.querySelector("input[selected]");
            const newSelection = this._offerFilterContainer?.querySelector(`input[value="${this._offerFilter}"]`);
            if (!currentSelection && newSelection) {
                newSelection.setAttribute("selected", "");
                newSelection.parentElement?.classList.add("active");
                return;
            }
            if (currentSelection == newSelection) {
                return;
            }
            currentSelection.removeAttribute("selected");
            currentSelection.parentElement?.classList.remove("active");
            newSelection.setAttribute("selected", "");
            newSelection.parentElement?.classList.add("active");
        };
        // Init
        this.addListeners = () => {
            this._slideoutToggle.addEventListener("click", this.openSlideout);
            this._slideoutShade.addEventListener("click", this.closeSlideout);
            this._slideoutCloseBtn.addEventListener("click", this.closeSlideout);
            this._slideoutApplyBtn.addEventListener("click", this.applyFilters);
            window.addEventListener("popstate", this.updateIfEmptyState);
            const typeFilters = this._slideout.querySelectorAll(".type__selected--input");
            for (const filter of typeFilters) {
                filter.addEventListener("change", this.setTypeFilter);
            }
            const tagFilters = this._slideout.querySelectorAll("select");
            for (const filter of tagFilters) {
                filter.addEventListener("change", this.setTagFilter);
            }
            const selectedTags = this._slideout.querySelectorAll(".tag__enabled--container");
            for (const tag of selectedTags) {
                tag.addEventListener("click", this.removeTagFilter);
            }
            const toggles = this._slideout.querySelectorAll("button.kind-toggle");
            for (const toggle of toggles) {
                toggle.addEventListener("click", this.toggleSection);
            }
        };
        this.setInitialFilters = (data) => {
            this._offerFilter = data.filteredOfferType ?? "";
            this._appliedTagFilters = data.filteredTags ?? [];
            this._appliedTypeFilters = data.filteredTypes ?? [];
            this._appliedTagFiltersByKind = data.filteredTagsByKind ?? {};
            this._selectedTypeFilters = this._appliedTagFilters;
            this._selectedTagFiltersByKind = this._appliedTagFiltersByKind;
        };
        // Filter
        this.applyFilters = (e) => {
            e.preventDefault();
            this._appliedTypeFilters = [...this._selectedTypeFilters];
            this._appliedTagFiltersByKind = {};
            const appliedTags = [];
            for (const kind in this._selectedTagFiltersByKind) {
                const tags = this._selectedTagFiltersByKind[kind];
                if (tags.length > 0) {
                    this._appliedTagFiltersByKind[kind] = tags;
                    appliedTags.push(...tags);
                }
            }
            this._appliedTagFilters = appliedTags;
            this._filter(this._offerFilter, this._appliedTypeFilters, this._appliedTagFilters);
            this.pushHistoryState();
            this.setOfferFilterStyle();
            this.closeSlideout();
        };
        this.setTypeFilter = (e) => {
            const box = e.currentTarget;
            if (box.checked && !this._selectedTypeFilters.includes(box.value)) {
                this._selectedTypeFilters.push(box.value);
            }
            else if (!box.checked) {
                this._selectedTypeFilters = this._selectedTypeFilters.filter((t) => t !== box.value);
            }
        };
        this.setTagFilter = (e) => {
            const select = e.currentTarget;
            const opt = select.options[select.selectedIndex];
            const kind = select.getAttribute("data-kind");
            const tagCode = opt.getAttribute("data-tag");
            const tagName = select.value;
            const tags = Array.isArray(this._selectedTagFiltersByKind[kind])
                ? [...this._selectedTagFiltersByKind[kind], tagCode]
                : [tagCode];
            this._selectedTagFiltersByKind[kind] = tags;
            opt.setAttribute("disabled", "true");
            const tagList = this.getTagList(kind);
            const tagSpan = this.buildSelectedTag(kind, tagCode, tagName);
            tagList.appendChild(tagSpan);
        };
        this.removeTagFilter = (e) => {
            const filter = e.currentTarget;
            const kind = filter.getAttribute("data-kind");
            const tag = filter.getAttribute("data-tag");
            filter.remove();
            this._selectedTagFiltersByKind[kind] = this._selectedTagFiltersByKind[kind].filter((t) => t !== tag);
            const select = this.getTagSelect(kind);
            const opt = select.querySelector(`[data-tag='${tag}']`);
            opt?.removeAttribute("disabled");
            select.selectedIndex = 0;
        };
        // Slideout
        this.openSlideout = () => {
            this._slideoutShade.removeAttribute("hidden");
            this._slideout.removeAttribute("hidden");
            this._slideout.focus();
            this._slideoutToggle.setAttribute("aria-expanded", "true");
            this._slideout.addEventListener("keydown", this.handleKeydown);
        };
        this.closeSlideout = () => {
            this._slideout.setAttribute("hidden", "true");
            this._slideoutShade.setAttribute("hidden", "true");
            this._slideoutToggle.focus();
            this._slideout.removeEventListener("keydown", this.handleKeydown);
        };
        this.handleKeydown = (e) => {
            const first = this._slideoutCloseBtn;
            const last = this._slideoutApplyBtn;
            handleModalKeydown(e, first, last, this.closeSlideout);
        };
        this.toggleSection = (e) => {
            const btn = e.currentTarget;
            const section = document.getElementById(btn.getAttribute("aria-controls"));
            if (section.hidden) {
                btn.setAttribute("aria-expanded", "true");
                section.removeAttribute("hidden");
            }
            else {
                btn.setAttribute("aria-expanded", "false");
                section.setAttribute("hidden", "true");
            }
        };
        // Get Elements
        this.buildSelectedTag = (kind, tagCode, tagName) => {
            const container = document.createElement("span");
            container.classList.add("tag__enabled--container", "stat-button-link");
            container.dataset.loc = "specials filters";
            container.setAttribute("role", "listitem");
            container.setAttribute("data-kind", kind);
            container.setAttribute("data-tag", tagCode);
            // Hoo boy does this page need Vue!
            container.innerHTML = `<span>${tagName}</span>
      <span class="close-button-container stat-button-close"
        data-loc="specials filters"
        aria-label="Remove tag ${tagName}"
        role="button"
        tabindex="0">
        <i class="fa fa-times tag__enabled custom-dealer-styling__close--black" aria-hidden="true"></i>
      </span>`;
            container.addEventListener("click", this.removeTagFilter);
            return container;
        };
        this.pushHistoryState = () => {
            let path = window.location.pathname;
            if (this._appliedTypeFilters.length > 0) {
                path = this.updateQueryStringParameter(path, "types", this._appliedTypeFilters.join(","));
            }
            if (this._appliedTagFilters.length > 0) {
                path = this.updateQueryStringParameter(path, "tags", this._appliedTagFilters.join(","));
            }
            if (this._offerFilter?.length > 0) {
                path = this.updateQueryStringParameter(path, "offerType", this._offerFilter);
            }
            const newurl = window.location.protocol + "//" + window.location.host + path;
            window.history.pushState({
                typeFilter: this._appliedTypeFilters,
                tagFilter: this._appliedTagFilters,
                offerFilter: this._offerFilter,
            }, "", newurl);
        };
        this.updateIfEmptyState = (e) => {
            if (e.state) {
                this._offerFilter = e.state.offerFilter ?? "";
                this._appliedTypeFilters = e.state.typeFilter ?? "";
                this._appliedTagFilters = e.state.tagFilter ?? "";
            }
            else {
                this.setFiltersFromUrl();
            }
            this._filter(this._offerFilter, this._appliedTypeFilters, this._appliedTagFilters);
            this.setOfferFilterStyle();
        };
        this.setFiltersFromUrl = () => {
            const urlParams = new URLSearchParams(window.location.search);
            this._offerFilter = urlParams.get("offerType") ?? "";
            this._appliedTypeFilters = urlParams.get("types")?.split(",") ?? [];
            this._appliedTagFilters = urlParams.get("tags")?.split(",") ?? [];
        };
        this.getTagList = (kind) => document.getElementById(`specialTags${kind}`);
        this.getTagSelect = (kind) => document.getElementById(`tagSelect${kind}`);
        this._slideoutToggle = document.getElementById("refineSearchButton");
        this._slideoutShade = document.getElementById("refineSidenavShade");
        this._slideout = document.getElementById("refineSidenav");
        this._slideoutCloseBtn = document.getElementById("refineSidenavClose");
        this._slideoutApplyBtn = document.getElementById("refineSidenavApply");
        this._offerFilterContainer = document.getElementById("offerFilterContainer");
        this._filter = filter;
        this.addListeners();
        this.setUpFilterAndState();
        this.setInitialFilters(initData);
        window.filterByOfferType = this.filterByOfferType.bind(this);
    }
    filterByOfferType(el) {
        const tag = el.firstElementChild.value;
        this._offerFilter = tag;
        this._filter(this._offerFilter, this._appliedTypeFilters, this._appliedTagFilters);
        this.pushHistoryState();
        this.setOfferFilterStyle();
    }
    updateQueryStringParameter(uri, key, value) {
        const re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
        const separator = uri.indexOf("?") !== -1 ? "&" : "?";
        if (uri.match(re)) {
            return uri.replace(re, "$1" + key + "=" + value + "$2");
        }
        else {
            return uri + separator + key + "=" + value;
        }
    }
}
